<template>
	<div rounded class="list-item-shield display-flex width-100 flex-space-between--center" v-on="$listeners" v-bind="$attrs">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ListItemShield',
};
</script>

<style lang="scss" scoped>
@import './list-item.scss';
.list-item-shield {
	min-height: 40px;
	padding: 0px 10px;
	background: $background-color;
	border: 1px solid var(--border-color);
	border-radius: 10px;
}
</style>
